import { render } from "./MarketTable.vue?vue&type=template&id=bd30d1ae&scoped=true"
import script from "./MarketTable.vue?vue&type=script&lang=js"
export * from "./MarketTable.vue?vue&type=script&lang=js"

import "./MarketTable.vue?vue&type=style&index=0&id=bd30d1ae&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd30d1ae"]])

export default __exports__